var pubFilter = "";

(function($) {
  "use strict";

  // https://gist.github.com/slavakraynov/f7b400ac9dd8671f4968d8e8aeeed95e
  jQuery.strtr = function(str, from, to) {
    var fr = "",
      i = 0,
      j = 0,
      lenStr = 0,
      lenFrom = 0,
      tmpStrictForIn = false,
      fromTypeStr = "",
      toTypeStr = "",
      istr = "";
    var tmpFrom = [];
    var tmpTo = [];
    var ret = "";
    var match = false;

    // Received replace_pairs?
    // Convert to normal from->to chars
    if (typeof from === "object") {
      for (fr in from)
        if (from.hasOwnProperty(fr)) {
          tmpFrom.push(fr);
          tmpTo.push(from[fr]);
        }

      from = tmpFrom;
      to = tmpTo;
    }

    // Walk through subject and replace chars when needed
    lenStr = str.length;
    lenFrom = from.length;
    fromTypeStr = typeof from === "string";
    toTypeStr = typeof to === "string";

    for (i = 0; i < lenStr; i++) {
      match = false;
      if (fromTypeStr) {
        istr = str.charAt(i);
        for (j = 0; j < lenFrom; j++)
          if (istr == from.charAt(j)) {
            match = true;
            break;
          }
      } else
        for (j = 0; j < lenFrom; j++)
          if (str.substr(i, from[j].length) == from[j]) {
            match = true;
            // Fast forward
            i = i + from[j].length - 1;
            break;
          }
      if (match) ret += toTypeStr ? to.charAt(j) : to[j];
      else ret += str.charAt(i);
    }

    return ret;
  };

  if ($("body").hasClass("filter-page")) {
    class PublicationsFilter {
      constructor(options) {
        this.options = $.extend({}, PublicationsFilter.defaults, options);
        this.request = window.location.search;
        this.filter = $.extend(
          {},
          PublicationsFilter.filter,
          this._urlQueryToObject(window.location.search)
        );

        Twig.extendFilter("slugify", function(text) {
          var trans = {
            а: "a",
            б: "b",
            в: "v",
            г: "g",
            д: "d",
            е: "e",
            ё: "jo",
            ж: "zh",
            з: "z",
            и: "i",
            й: "jj",
            к: "k",
            л: "l",
            м: "m",
            н: "n",
            о: "o",
            п: "p",
            р: "r",
            с: "s",
            т: "t",
            у: "u",
            ф: "f",
            х: "kh",
            ц: "c",
            ч: "ch",
            ш: "sh",
            щ: "shh",
            ъ: "",
            ы: "y",
            ь: "",
            э: "eh",
            ю: "ju",
            я: "ja",
          };
          return jQuery
            .strtr(text.toLowerCase(), trans) // transliterate cyrillic letters
            .replace(/[^A-Za-z0-9 _.]/g, "") // leave only known characters
            .replace(/[ _\.]+/g, "-") // convert 'space', '_', '.' into '-'
            .replace(/^-|-$/gm, ""); // remove '-' from start and end of the text
        });

        this._getPublications = function(data) {
          var _this = this,
            handler = function(response) {
              if (true === response.success && response.data.response) {
                var documents = response.data.response.documents,
                  $filters = response.data.response.terms,
                  container = $("#filter-block"),
                  count = response.data.response.count,
                  {
                    strings,
                    search,
                    favorites,
                    pagination,
                    static_data,
                    is_logged_in,
                  } = response.data;

                if (!documents.length) {
                  return false;
                }

                if (5 >= documents.length) {
                  const url = createHydroTheekUrl();

                  setHydrotheekButtonUrl(url);

                  showHydrotheekSection();
                }

                if (strings.search) {
                  $("#search").val(strings.search.replace(/[\\]+/g, ""));
                }

                $(".result-count").html(count);

                // Render publications
                let innerHTML = Twig.twig({
                  ref: "publication-template",
                }).render({
                  response: {
                    documents,
                    favorites,
                  },
                  static_data,
                  is_logged_in,
                });

                $(`.${_this.options.containerClass}`)
                  .find(".table-body")
                  .html(innerHTML);

                // Render pagination
                if (0 < pagination.total) {
                  var paginationHTML = Twig.twig({
                    ref: "publications-pagination",
                  }).render({ pagination });

                  $(`.${_this.options.paginationContainer}`).html(
                    paginationHTML
                  );
                }

                var filtersHTML = Twig.twig({
                  ref: "filters-block-list",
                }).render({
                  strings: response.data.strings,
                  response: {
                    terms: $filters,
                  },
                  filters: response.data.filters,
                });
                container.html(filtersHTML);

                $(".horizontal-scrollbar").perfectScrollbar();
                $(".vertical-scrollbar").perfectScrollbar({
                  suppressScrollX: true,
                });
              } else {
                var container = $(".filter-block");

                container.html("");

                container.html(
                  Twig.twig({
                    ref: "no-results",
                  }).render(response.data)
                );

                document.getElementById("results-section").remove();
                document
                  .getElementById("hydrotheek-section")
                  .classList.remove("is-hidden");

                const url = createHydroTheekUrl();
                setHydrotheekButtonUrl(url);
              }
            };
          var getPublications = function(data) {
            return new Promise((resolve, reject) => {
              if (data) {
                resolve(data);
              }
              $.ajax({
                type: "POST",
                url: KWR.ajaxurl,
                dataType: "json",
                data: {
                  filter: "?" + _this._objToUrlQuery(_this._getFilter()),
                  action: _this.options.action,
                  current: _this._getFilter().n || 1,
                },
                beforeSend: function() {
                  $(`.${_this.options.containerClass}`)
                    .addClass("js-loading")
                    .find(".table-body")
                    .html("");
                },
                success: response => {
                  resolve(response);
                },
              });
            });
          };
          getPublications(data)
            .then(data => {
              handler(data);
            })
            .then(
              function() {
                $(`.${_this.options.containerClass}`).removeClass("js-loading");
                window.dispatchEvent(new Event("resize"));
              },
              function() {
                $(`.${_this.options.containerClass}`).removeClass("js-loading");
                window.location.reload();
              }
            );
        };

        this._init();
      }

      _init() {
        this._template = twig({
          id: this.options.publicationTemplate,
          href: KWR.view + "parts/publication-template.twig",
          async: true,
          load: function(template) {
            $body.addClass("js-template-loaded");
          },
        });

        this._paginationTemplate = twig({
          id: this.options.paginationTemplate,
          href: KWR.view + "parts/publications-pagination.twig",
          async: true,
          load: function(template) {
            $body.addClass("js-template-loaded");
          },
        });

        this._noResultsTemplate = twig({
          id: this.options.noResultsTemplateId,
          href: KWR.view + "parts/no-results.twig",
          async: true,
          load: function(template) {
            $body.addClass("js-template-loaded");
          },
        });

        this._filtersList = twig({
          id: "filters-block-list",
          href: KWR.view + "parts/filter-block.twig",
          async: true,
          namespaces: {
            parts: KWR.view + "parts/",
          },
          load: function(template) {
            $body.addClass("js-template-loaded");
          },
        });

        this.pagination = $(`.${this.options.paginationContainer}`);

        this._events();
      }

      _events() {
        this._handleSortClick();
        this._handlePaginationClick();
        this._handleHistoryChange();
      }

      _handleSortClick() {
        var _this = this;
        $(".sort-button").on("click", function() {
          const order = $(this).data("order");
          const orderby = $(this).data("orderby");
          _this._setFilter({
            orderby,
            order,
          });
          _this._buildRequest();
        });

        $(".sort-title").on("click", function() {
          function getUrlParameter(name) {
            name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
            var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
            var results = regex.exec(location.search);
            return null === results
              ? ""
              : decodeURIComponent(results[1].replace(/\+/g, " "));
          }

          const orderby = $(this).data("orderby");
          var order;

          if (
            getUrlParameter("orderby") == orderby &&
            "asc" == getUrlParameter("order")
          ) {
            order = "desc";
          } else {
            order = "asc";
          }

          _this._setFilter({
            orderby,
            order,
          });
          _this._buildRequest();
        });
      }

      _handlePaginationClick() {
        var _this = this;
        _this.pagination.on("click", ".page:not(.current)", e => {
          e.preventDefault();
          e.stopPropagation();
          var page = e.target.getAttribute("data-page") || 1;

          _this._setFilter({
            n: parseInt(page, 10),
          });

          _this._buildRequest();
        });

        _this.pagination.on(
          "click",
          ".pagination-previous:not(.disabled)",
          e => {
            e.preventDefault();
            e.stopPropagation();
            var page = parseInt(this._getFilter().n, 10);

            if (1 < page) {
              _this._setFilter({
                n: parseInt(this._getFilter().n, 10) - 1,
              });

              _this._buildRequest();
            }
          }
        );

        _this.pagination.on("click", ".pagination-next:not(.disabled)", e => {
          e.preventDefault();
          e.stopPropagation();

          _this._setFilter({
            n: parseInt(this._getFilter().n, 10) + 1,
          });

          _this._buildRequest();
        });
      }

      _handleHistoryChange() {
        var _this = this;
        /**
         * Listen to filter change
         * update current filter state within new set of filters
         */
        $(document).on("filterHasChanged", function(e, data) {
          //get all current data and remove not used filters state
          // const filters = PublicationsFilter.filter;
          _this._setFilter(data, false);
        });
        window.onpopstate = event => {
          _this._setFilter(event.state || {}, false);
          _this._buildRequest(false);
        };
      }

      _buildRequest(h) {
        var request = "?" + this._objToUrlQuery(this._getFilter());
        // console.log(request);

        if ("undefined" === typeof h) {
          h = true;
        }

        if (h) {
          history.pushState(
            this._getFilter(),
            "Filter | Page - " + this._getFilter().n,
            window.location.pathname + request
          );
        }
        // set reference url
        localStorage.setItem(
          "reference_url",
          window.location.pathname + request
        );

        // grab publications
        this._getPublications();
      }

      _getFilter() {
        return $.extend(
          {},
          this._urlQueryToObject(window.location.search),
          PublicationsFilter.filter
        );
      }

      _setFilter(object, applyFilters = true) {
        var filter = this._getFilter();

        const curFilters = filter && filter.n ? { n: filter.n } : {};

        if (Object.keys(object).length > 2 && object.hasOwnProperty("n")) {
          delete object["n"];
        }

        PublicationsFilter.filter = $.extend(
          {},
          applyFilters ? filter : curFilters,
          object
        );
      }

      _objToUrlQuery(obj) {
        return Object.keys(obj).reduce((query, key) => {
          if (query) query = query + "&";
          query = query + key + "=" + obj[key];
          return query;
        }, "");
      }

      _removeEmptyUrlParams(urlparams) {
        if ("string" === typeof urlparams) {
          return urlparams.replace(/[^=&]+=(&|$)/g, "").replace(/&$/, "");
        }
      }

      _urlQueryToObject(query) {
        if ("string" === typeof query && "" !== query) {
          return JSON.parse(
            '{"' +
              decodeURI(query)
                .replace("?", "")
                .replace(/"/g, '\\"')
                .replace(/&/g, '","')
                .replace(/=/g, '":"') +
              '"}'
          );
        }
      }
    }

    PublicationsFilter.defaults = {
      containerClass: "table-overview",
      resultsClass: "return-page",
      action: "searchPublications",
      publicationTemplate: "publication-template",
      paginationTemplate: "publications-pagination",
      noResultsTemplateId: "no-results",
      paginationContainer: "blog-pagination",
      publicationUrl: KWR.publicationUrl,
      navigationClass: "filter-navigation", // hide when no results
    };

    PublicationsFilter.filter = {
      // n: 1,
    };
    // console.log('pubs');

    // if ($('body').hasClass('page-template-publicaties')) {
    pubFilter = new PublicationsFilter();
    // }
  }
})(jQuery);
